var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurgermenuClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140.81 132.1",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "burgermenu-close_svg__cls-1",
  d: "m28.668 97.985 74.55-74.55 7.41 7.41-74.55 74.55z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "burgermenu-close_svg__cls-1",
  d: "m103.215 105.392-74.55-74.55 7.41-7.41 74.55 74.55z"
})));
export { SvgBurgermenuClose as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iRWJlbmVfMiIgZGF0YS1uYW1lPSJFYmVuZSAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDAuODEgMTMyLjEiPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTYuOTMiIHk9IjU5LjE4IiB3aWR0aD0iMTA1LjQzIiBoZWlnaHQ9IjEwLjQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjUuMTUgNjguMTEpIHJvdGF0ZSgtNDUpIi8+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxNi45MyIgeT0iNTkuMTgiIHdpZHRoPSIxMDUuNDMiIGhlaWdodD0iMTAuNDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczLjM0IDE1OS4yMSkgcm90YXRlKC0xMzUpIi8+Cjwvc3ZnPg==";